import React from 'react';

class View extends React.Component {

  render() {
    let i = this.props.serialNumber;
    return (
      <div>
        <table id="table" width="100%">
          <tr>
            <th id='th' style={{width: '7%'}}><center>Sino</center></th>
            <th id='th' onClick={ () => { this.props.getStockDetails1('partno', this.props.sortingOrder) }}><center>Spare Name</center></th>
            <th id='th' onClick={ () => { this.props.getStockDetails1('brand_name', this.props.sortingOrder) }}><center>Brand Name</center></th>
            <th id='th' onClick={ () => { this.props.getStockDetails1('name', this.props.sortingOrder) }}><center>Branch</center></th>
            <th id='th'><center>Stock Available</center></th>
            <th id='th'><center>Reserved Stock</center></th>
            <th id='th'><center>Waiting Stock</center></th>
            <th id='th'><center>Approved Stock</center></th>
            <th id='th'><center>Pending Request</center></th>
            <th id='th'><center>Sample Request</center></th>
          </tr>
          { this.props.spareanalytics.map((s) => {
              let background = 'white';
              if (s.moving == 'Slow') {
                background = '#FFDAD2';
              }
              if (s.moving == 'Avarage') {
                background = '#FEF4C9';
              }
              if (s.moving == 'Very Fast') {
                background = '#CFFEC9';
              }
              i++;
              return (
                <tr style={{backgroundColor: background}}>
                  <td><center>{i}</center></td>
                  <td>{s.partno+'->'+s.spare_name}</td>
                  <td>{s.brand_name}</td>
                  <td>{s.name}</td>
                  <td><center>{s.ava_stocks}</center></td>
                  <td><center>{s.pendingDelivery}</center></td>
                  <td><center>{s.Waiting}</center></td>
                  <td><center>{s.Approved}</center></td>
                  <td><center>{s.pendingRequest}</center></td>
                  <td><center>{s.samplePendingRequest}</center></td>
                </tr>
              )
            })
          }
        </table>
      </div>
    );
  }
}

export default View;
